export default __webpack_public_path__ + "static/media/book_image2.e60ec385.jfif";